import { render, staticRenderFns } from "./PrescriptionImageComponent.vue?vue&type=template&id=02984084&scoped=true"
import script from "./PrescriptionImageComponent.vue?vue&type=script&lang=ts"
export * from "./PrescriptionImageComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02984084",
  null
  
)

export default component.exports